(function () {
  if (!window.customElements) return;

  const AUTOPLAY_SELECTOR = 'slider-component[data-autoplay="true"]';

  function getLastPosition(sliderComponent) {
    return (
      (sliderComponent.sliderItemsToShow.length - sliderComponent.slidesPerPage) *
      sliderComponent.sliderItemOffset
    );
  }

  function setupSlider(sliderComponent) {
    const slider = sliderComponent.slider;
    const prevButton = sliderComponent.prevButton;
    const nextButton = sliderComponent.nextButton;

    if (!slider || !prevButton || !nextButton) return;

    // Keep both arrows enabled so the slider can loop in both directions.
    sliderComponent.enableSliderLooping = true;

    const speed = (parseFloat(slider.dataset.speed) || 5) * 1000;
    let timer = null;

    const play = function () {
      clearInterval(timer);
      timer = setInterval(advance, speed);
    };

    const pause = function () {
      clearInterval(timer);
    };

    const advance = function () {
      const nextPosition = slider.scrollLeft + sliderComponent.sliderItemOffset;
      slider.scrollTo({ left: nextPosition > getLastPosition(sliderComponent) ? 0 : nextPosition });
    };

    // Intercept arrow clicks in the capture phase so Dawn's non-looping
    // handler never runs, then scroll with wrap-around.
    sliderComponent.addEventListener(
      'click',
      function (event) {
        const button = event.target.closest('button[name="previous"], button[name="next"]');
        if (!button) return;

        event.stopPropagation();

        if (button === nextButton) {
          const nextPosition = slider.scrollLeft + sliderComponent.sliderItemOffset;
          slider.scrollTo({
            left: nextPosition > getLastPosition(sliderComponent) ? 0 : nextPosition,
          });
        } else {
          const prevPosition = slider.scrollLeft - sliderComponent.sliderItemOffset;
          slider.scrollTo({ left: prevPosition < 0 ? getLastPosition(sliderComponent) : prevPosition });
        }

        play();
      },
      true
    );

    sliderComponent.addEventListener('mouseenter', pause);
    sliderComponent.addEventListener('mouseleave', play);
    sliderComponent.addEventListener('focusin', pause);
    sliderComponent.addEventListener('focusout', play);

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) play();
  }

  function setupAll() {
    document.querySelectorAll(AUTOPLAY_SELECTOR).forEach(setupSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }

  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        node.querySelectorAll?.(AUTOPLAY_SELECTOR).forEach(setupSlider);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
